import reducer from './reducers';

export { default as campusesOperations } from './operations';
export { default as campusesSelectors } from './selectors';
export { default as campusesTypes } from './types';

export default reducer;
